
import Vue from 'vue';
import Pagination from '@/components/Pagination/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import { getFinancial, GetFinancialParams } from '@/services/territory/get-financial';
import { getFinancialPix } from '@/services/territory/get-financial-pix';
import Table from '@/components/TableAdapterMix/index.vue';
import { Wrapper } from './styles';

export enum TicketStatusData {
  PENDING = 'pending',
  PAYED = 'payed',
  CANCELLED = 'cancelled',
  LATE = 'late',
  SETTLED = 'settled'
}

export default Vue.extend({
  components: {
    Wrapper, Table, Pagination, ResultMessage,
  },
  inject: ['userLogged'],
  data() {
    return {
      loading: true,
      headers: [
        { key: 'name', value: 'Produtor', isOrder: true },
        { key: 'nameTerritory', value: 'Território' },
        { key: 'paymentMethods', value: 'Forma de pagamento', tag: true },
        { key: 'penaltyInstallments', value: 'Parcelas' },
        { key: 'trafficTicket', value: 'Valor da multa indenizatória', html: true },
        { key: 'status', value: 'Status', tag: true },
      ] as any[],
      data: [],
      dataPix: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    tickets(): any[] {
      return this.data.map((ticket: any) => ({
        status: ticket.ticketInfo.totalInstallmentsPayed.toString() === ticket.ticketInfo.totalInstallments.toString()
          ? 'Quitado' : this.getTicketStatus(ticket.status),
        name: ticket.agents[0].name,
        nameTerritory: ticket.name,
        id: ticket.cdterritory,
        trafficTicket: this.formatNumberToBrl(ticket.ticketInfo.totalAmount),
        penaltyInstallments: `${ticket.ticketInfo.totalInstallmentsPayed}/${ticket.ticketInfo.totalInstallments}`,
        paymentMethods: 'Boleto',
        type: 'Financial',
      }));
    },
    pixData(): any[] {
      const options = {
        style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 3,
      };
      const formatNumber = new Intl.NumberFormat('pt-BR', options);
      return this.dataPix.map((pix: any) => ({
        status: this.getTicketStatus(pix.status),
        name: pix.agents[0].name,
        nameTerritory: pix.name,
        id: pix.cdterritory,
        trafficTicket: pix.valor?.original ? `${formatNumber.format(pix.valor?.original)}` : `<span title="${pix.valor?.mensagem}"> - </span>`,
        penaltyInstallments: '1',
        paymentMethods: 'PIX',
        type: 'Financial',
      }));
    },
  },
  methods: {
    formatNumberToBrl(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    setOffset(page: number) {
      this.pagination.page = page;
      this.getFinancialRequest(page);
    },
    setOffset2(page: number) {
      this.pagination.page = page;
      if (this.data.length === 0 && this.dataPix.length === 0) {
        this.pagination.page = page;
        this.getFinancialRequest(page);
      }
      this.getFinancialRequest(page);
    },
    async getFinancialRequest(page = 1, pageSize = 5) {
      this.loading = true;
      const params: GetFinancialParams = {
        page,
        pageSize,
      };
      let condition = false;
      let responsePix = await getFinancialPix({ page, pageSize: 6 });
      let response = await getFinancial(params);
      if (responsePix?.results.length === 0) {
        response = await getFinancial({ page, pageSize: 10 });
        condition = true;
      } else if (responsePix?.results.length === 5) {
        response = await getFinancial(params);
      } else if (response?.results.length === 0) {
        responsePix = await getFinancialPix({ page, pageSize: 10 });
      } else if (responsePix?.results.length < 5 && responsePix?.results.length !== 0) {
        const size = response?.results.length - responsePix?.results.length;
        response = await getFinancial({ page, pageSize: 5 + size });
      }
      if (response.hasErrors) {
        this.data = [];
        this.loading = false;
      }
      if (condition === false) {
        this.data = response?.results || [];
      } else {
        this.data = response?.results || [];
      }
      this.dataPix = responsePix?.results || [];
      this.pagination.total = response?.rowCount + responsePix?.rowCount || 0;
      this.loading = false;
    },
    getTicketStatus(status: string) {
      const ticketStatus = {
        [TicketStatusData.LATE]: 'Em atraso',
        [TicketStatusData.PAYED]: 'Quitado',
      };

      return ticketStatus[status] || 'Em dia';
    },
  },
  created() {
    this.getFinancialRequest();
  },
});
